import { render } from "./BuyerPage.vue?vue&type=template&id=0b1ee2d2&scoped=true"
import script from "./BuyerPage.vue?vue&type=script&lang=js"
export * from "./BuyerPage.vue?vue&type=script&lang=js"

import "./BuyerPage.vue?vue&type=style&index=0&id=0b1ee2d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1ee2d2"]])

export default __exports__